/**
 * @flow
 * @relayHash 485e430f55048f18cf3b76d360f09a20
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContractSignatureBlockInput = {
  clientMutationId?: ?string,
  id: string,
};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutationVariables = {|
  input: DeleteContractSignatureBlockInput
|};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutationResponse = {|
  +deleteContractSignatureBlock: ?{|
    +deletedContractSignatureBlockId: ?string
  |}
|};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutation = {|
  variables: SignatureBlocks_Contract_deleteContractSignatureBlockMutationVariables,
  response: SignatureBlocks_Contract_deleteContractSignatureBlockMutationResponse,
|};
*/


/*
mutation SignatureBlocks_Contract_deleteContractSignatureBlockMutation(
  $input: DeleteContractSignatureBlockInput!
) {
  deleteContractSignatureBlock(input: $input) {
    deletedContractSignatureBlockId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractSignatureBlockInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContractSignatureBlock",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteContractSignatureBlockInput!"
      }
    ],
    "concreteType": "DeleteContractSignatureBlockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedContractSignatureBlockId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
  "id": null,
  "text": "mutation SignatureBlocks_Contract_deleteContractSignatureBlockMutation(\n  $input: DeleteContractSignatureBlockInput!\n) {\n  deleteContractSignatureBlock(input: $input) {\n    deletedContractSignatureBlockId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fc5d291826c284800dc169c1cfd8143f';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/SignatureBlocks_Contract_deleteContractSignatureBlockMutation.graphql.js